function rebaseFrom(rebaseOption) {
  return undefined === rebaseOption ? true : !!rebaseOption;
}

module.exports = rebaseFrom;



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-css/lib/options/rebase.js
// module id = 1047
// module chunks = 0